import { Injectable, ElementRef } from '@angular/core';
import { Repository, FrameContext, NgFormControl } from '@farris/devkit';
import { FrameContextService } from './frame-context.service';
import { FormControlService } from './form-control.service';

const FIXED_COLUMN_START_INDEX = 5000;
const GRID_COLUMN_START_INDEX = 10000;
interface FocusableInvalidationGrid {
  editCell(rowId: any, field: string): void;
  disabled: boolean;
}

/**
 * è¡¨åéªè¯æå¡
 * @scope FrameComponent
 */
@Injectable()
class FocusInvalidService {
  /**
   * æé å½æ°
   */
  constructor(
    private repository: Repository<any>,
    private frameContext: FrameContext,
    private frameContextService: FrameContextService,
    private formControlService: FormControlService
  ) {
  }

  /**
   * åç¬¬ä¸ä¸ªéªè¯ä¸éè¿çå­æ®µè®¾ç½®ç¦ç¹
   */
  public focusInvalidInput(verifyInformations: any[], rootElement: ElementRef<any>) {
    // æ éªè¯ä¸éè¿ä¿¡æ¯æ¶ï¼ç´æ¥è¿åã
    if (!verifyInformations || !verifyInformations.length) {
      return;
    }
    let targetField = null;
    const firstVerifyInformation = this.selectFirstVerifyInformation(verifyInformations, rootElement);
    if (firstVerifyInformation) {
      targetField = firstVerifyInformation.targetField;
      if (targetField) {
        const canFocus = this.focusElement(targetField, rootElement);
        if (canFocus) {
          verifyInformations['focused'] = true;
        }
      }
    }
  }

  /**
   * è®¾ç½®DataGridååæ ¼ç¦ç¹
   */
  public focusGridCell(verifyInformations: any[], focusableDataGrid: FocusableInvalidationGrid) {
    if (!verifyInformations || !verifyInformations.length || verifyInformations['focused'] == true || focusableDataGrid.disabled === true) {
      return;
    }
    let targetField = null;
    let targetId = null;
    const firstVerifyInformation = this.selectFirstVerifyInformation(verifyInformations);
    if (firstVerifyInformation) {
      targetField = firstVerifyInformation.targetField;
      targetId = firstVerifyInformation.id;
      verifyInformations['focused'] = true;
      focusableDataGrid.editCell(targetId, targetField);
    }
  }
  private updateVerifyInformationsIndex(verifyInformations: any[], rootElement?: ElementRef<any>) {
    verifyInformations = verifyInformations.filter((verifyInformation: any) => {
      const frameContexts = this.getFrameContextsByPropertyPath(verifyInformation.fullPath, '/');
      const frameContext = frameContexts && frameContexts.filter(frameContext => frameContext && frameContext.frameId === this.frameContext.frameId);
      return frameContext ? true : false;
    });
    return verifyInformations.map((verifyInformation: any) => {
      let tabIndex = -1;
      if (verifyInformation) {
        if (rootElement && verifyInformation.targetField) {
          const input = this.getInputElementById(verifyInformation.targetField, rootElement);
          tabIndex = input && input.getAttribute('tabindex') || -1;
          tabIndex = Number(tabIndex);
        }
        // const frameContexts = this.getFrameContextsByPropertyPath(verifyInformation.fullPath, '/');
        const frameContext = this.frameContext;//frameContexts && frameContexts[0] || null;
        const frameIndex = frameContext.index + 1;
        verifyInformation.tabIndex = tabIndex;
        verifyInformation.domIndex = -1;
        verifyInformation.frameIndex = -1;
        verifyInformation.position = tabIndex;
        if (frameContext) {
          const domIndex = verifyInformation.fullPath && this.getFieldIndex(frameContext, verifyInformation.fullPath) || 0;
          if (domIndex > 0) {
            const rowIndex = verifyInformation.index || 0;
            verifyInformation.domIndex = domIndex;
            verifyInformation.frameIndex = frameContext.index;
            verifyInformation.position = tabIndex > 0 ? tabIndex : (frameIndex * 1000 + rowIndex * 1000 + domIndex);
          }
        }
      }
      return verifyInformation;
    });
  }
  private isGridComponent(frameContext: FrameContext) {
    if (frameContext) {
      const dataGridColumnsName = frameContext.viewModel['dataGridColumnsName'] || null;
      return dataGridColumnsName ? true : false;
    }
    return undefined;
  }
  private getColumnIndex(frameContext: FrameContext, binding: string) {
    binding = binding.split('/').filter(p => p).join('/');
    const bindingPaths = frameContext.viewModel.bindingPath.split('/').filter(p => p);
    const dataGridColumnsName = frameContext.viewModel['dataGridColumnsName'] || null;
    const frameIndex = frameContext.index + 1;
    if (!dataGridColumnsName) {
      return undefined;
    }
    let columns: any[] = frameContext.viewModel[dataGridColumnsName];
    if (!columns || columns.length < 1) {
      return undefined;
    }
    // æå¹³columns
    columns = columns.reduce((results: any[], item) => {
      if (Array.isArray(item)) {
        return results.concat(item);
      }
      return results.concat([item]);
    }, []);
    let position = -1;
    for (let index = 0; index < columns.length; index++) {
      const column: any | any[] = columns[index];
      const fields = column && column.field && column.field.split('.').filter(p => p) || null;
      if (!fields) {
        continue;
      }
      if (bindingPaths.concat(fields).join('/') === binding) {
        const fixed = column.fixed;
        if (fixed) {
          const fixedColumns = columns.filter(item => item.fixed === fixed);
          const fixedColumnIndex = this.getIndexFromColumns(fixedColumns, binding);
          if (fixed === 'left') {
            position = frameIndex * FIXED_COLUMN_START_INDEX + fixedColumnIndex;
          } else {
            position = frameIndex * GRID_COLUMN_START_INDEX + 1000 + fixedColumnIndex;
          }
        } else {
          position = frameIndex * GRID_COLUMN_START_INDEX + index;
        }
        break;
      }
    }
    return position;
  }
  private getIndexFromColumns(columns: any[], binding: string) {
    const bindingPaths = this.frameContext.viewModel.bindingPath.split('/').filter(p => p);
    return columns.findIndex(column => {
      const fields = column && column.field && column.field.split('.').filter(p => p) || null;
      if (!fields) {
        return false;
      }
      if (bindingPaths.concat(fields).join('/') === binding) {
        return true;
      }
      return false;
    });
  }
  private selectFirstVerifyInformation(verifyInformations: any[], rootElement?: ElementRef<any>) {
    verifyInformations = this.updateVerifyInformationsIndex(verifyInformations, rootElement);
    verifyInformations.sort((v1: any, v2: any) => Number(v1.position) - Number(v2.position));
    return verifyInformations && verifyInformations.length > 0 && verifyInformations[0] || null;
  }
  private getInputElementById(targetField: string, rootElement: ElementRef<any>) {
    let element = rootElement.nativeElement.ownerDocument.getElementById(targetField) || null;
    if (element && element.tagName !== 'INPUT') {
      const inputs = element.getElementsByTagName('input');
      if (inputs.length) {
        element = inputs[0];
      }
    }
    return element;
  }
  public getFrameContextsByPropertyPath(propertyPath: string, separtor: string = '/'): FrameContext[] {
    if (!propertyPath) {
      return [];
    }
    const frameContexts = this.frameContext && this.frameContext.appContext.frameContextManager.getFrameContexts() || [];
    return frameContexts.filter((frameContext: FrameContext) => {
      const formControls = frameContext && frameContext.form && frameContext.form.ngFormControls || {};
      const bindingPath = frameContext && frameContext.viewModel && frameContext.viewModel.bindingPath || '';
      if (formControls && Object.keys(formControls).length > 0) {
        const key = Object.keys(formControls).find((key: string) => {
          const formControl = formControls[key];
          if (!formControl || !formControl.binding) {
            return false;
          }
          const bindings = formControl.binding.split('.').filter(p => p);
          const bindingPaths = bindingPath.split('/').filter(p => p);
          const fullPath = bindingPaths.concat(bindings);
          return propertyPath.split(separtor).filter(p => p).join('/') === fullPath.join('/');
        });
        return key ? true : false;
      }
      return false;
    });
  }
  public getFormControlIndexByBindingPath(frameContext: FrameContext, binding: string): number {
    const ngFormControls = this.getFormControlsByFrameContext(frameContext);
    if (!ngFormControls) {
      return null;
    }
    const bindings = binding.split('/').filter(p => p);
    return Object.values(ngFormControls).findIndex((ngFormControl: NgFormControl) => {
      if (!ngFormControl) {
        return false;
      }
      const bindingPath = frameContext.viewModel.bindingPath;
      const bindingPaths = bindingPath.split('/').filter(p => p);
      const formControlBindingPaths = ngFormControl.binding.split('.').filter(p => p);
      const fullPath = bindingPaths.concat(formControlBindingPaths);
      return fullPath.join('/') === bindings.join('/');
    });
  }
  public getFieldIndex(frameContext: FrameContext, binding: string) {
    const isGridComponent = this.isGridComponent(frameContext);
    if (isGridComponent) {
      return this.getColumnIndex(frameContext, binding);
    } else {
      return this.getFormControlIndexByBindingPath(frameContext, binding);
    }
  }
  public getFormControlsByFrameContext(frameContext: FrameContext): { [propertyName: string]: NgFormControl } | null {
    return frameContext && frameContext.form && frameContext.form.ngFormControls || null;
  }
  public focusElement(elementId: string, rootElement: ElementRef<any>): boolean {
    let focused = false;
    let elementToFocus = rootElement.nativeElement.ownerDocument.getElementById(elementId);
    // æªè·åå°æå®å­æ®µæ¶ï¼è¿åï¼ä¸åè®¾ç½®ç¦ç¹ã
    if (elementToFocus) {
      // å¦ææå¤ä¸ªidéå¤çåç´ ï¼åä¸å®ä½
      const elements = rootElement.nativeElement.ownerDocument.querySelectorAll(`#${elementId}`);
      if (elements && elements.length > 1) {
        return focused;
      }
      // å¦æç»å®ç®æ å­æ®µçæ§ä»¶ä¸æ¯Inputåç´ ï¼åæ¥æ¾å¶ä¸çº§èç¹ã
      if (elementToFocus.tagName !== 'INPUT') {
        const subElements = elementToFocus.getElementsByTagName('input');
        if (subElements.length) {
          elementToFocus = subElements[0];
        }
      }
      elementToFocus.focus();
      focused = true;
    }
    return focused;
  }
  /**
   * è®¾ç½®ç¦ç¹
   * @param verifyInformation éè¯¯ä¿¡æ¯
   * @param frameContext ä¸ä¸æ
   * @returns 
   */
  public focus(verifyInformation: any, frameContext: FrameContext) {
    if (!verifyInformation) {
      return;
    }
    const isGridValidation = verifyInformation.index !== null;
    if (isGridValidation) {
      const grid = this.getGridRef(frameContext);
      if (grid) {
        setTimeout(() => {
          grid.editCell(verifyInformation.id, verifyInformation.targetField);
        }, 0);
      }
    } else {
      const frameElement = this.getComponentRef(frameContext);
      const elementId = verifyInformation.targetField;
      this.focusById(elementId, frameElement);
    }
  }

  /**
   * éè¿æ§ä»¶idè®¾ç½®ç¦ç¹
   * @param elementId 
   * @param elementRef 
   */
  private focusById(elementId: string, elementRef?: ElementRef) {
    const document: any = elementRef && elementRef.nativeElement.ownerDocument || window.document;
    if (document) {
      const element = document.getElementById(elementId);
      if (element.tagName !== 'INPUT') {
        const subElements = element.getElementsByTagName('input');
        if (subElements.length) {
          const input = subElements[0];
          if (input && typeof input.focus === 'function') {
            input.focus();
          }
        }
      } else {
        element.focus();
      }
    }
  }
  /**
   * è·åç»ä»¶å®ä¾
   * @param frameContext 
   * @returns 
   */
  private getComponentRef(frameContext: FrameContext) {
    return this.frameContext && this.frameContext.injector.get<ElementRef>(ElementRef, null) || null;
  }
  /**
   * è·ågridå®ä¾
   * @param frameContext frameContext
   * @returns 
   */
  private getGridRef(frameContext: FrameContext): FocusableInvalidationGrid {
    const namespace = frameContext.namespace;
    const bindingPath = frameContext.viewModel.bindingPath;
    const frameContexts: FrameContext[] = this.frameContext.appContext.frameContextManager.getFrameContextsByNamespace(namespace) || [];
    const matchedFrameContexts = frameContexts.filter((frameContext: FrameContext) => frameContext.viewModel && frameContext.viewModel.bindingPath.split('/').filter(p => p).toString() === bindingPath.split('/').filter(p => p).toString());
    let result = null;
    if (matchedFrameContexts) {
      matchedFrameContexts.every((frameContext: FrameContext) => {
        const frameId = frameContext.frameId;
        const componentsMap = this.frameContext.appContext.componentManager.getComponentsByFrameId(frameId);
        if (!componentsMap) {
          return true;
        }
        const datagridComponent = Array.from(componentsMap.values()).find((component: any) => component && component['__component_type__'] === 'DatagridComponent');
        if (datagridComponent) {
          result = datagridComponent;
          return false;
        } else {
          return true;
        }
      });
    }
    return result;
  }
}

export { FocusableInvalidationGrid, FocusInvalidService };
